import {handleResponse} from ".";
import {useState} from "react";

const API = process.env.REACT_APP_API_URL;

// const [user, setUser] = useState(null);

export const sendLoginOTP = (body) =>
{
    const url = `${API}/web/user-login`;
    // console.log("API URL: " + url);

    const otpBody = JSON.stringify(body);
    // console.log("Token 2FA body: " + otpBody);

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: otpBody,
    }).then(response =>
    {
        // console.log("otp response: " + JSON.stringify(response));
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const logoutUser = () =>
{
    const url = `${API}/web/user-logout`;

    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${isAuthenticated()}`,
        },
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const refreshToken = (email) =>
{
    const url = `${API}/web/refresh-token/${email}`;
    // console.log("API URL: " + url);

    const otpBody = JSON.stringify(body);
    // console.log("Token 2FA body: " + otpBody);

    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        body: otpBody,
    }).then(response =>
    {
        // console.log("otp response: " + JSON.stringify(response));
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const resendOTP = (body) =>
{
    const url = `${API}/web/resend-otp`;
    // console.log("API URL: " + url);

    const otpBody = JSON.stringify(body);
    // console.log("Token 2FA body: " + otpBody);

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: otpBody,
    }).then(response =>
    {
        // console.log("otp response: " + JSON.stringify(response));
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const verifyLoginOTP = (body) =>
{
    const url = `${API}/web/auth-user`;
    // console.log("API URL: " + url);

    const otpBody = JSON.stringify(body);
    // console.log("Verify Token 2FA body: " + otpBody);

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: otpBody,
    }).then(response =>
    {
        // console.log("otp response: " + JSON.stringify(response));
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const getAuthUser = () =>
{
    return fetch(`${API}/web/get-auth-user`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${isAuthenticated()}`,
        },
    }).then(handleResponse).then(response =>
    {
        // setUser(response.data);
        return response.json();
    }).catch(err =>
    {
        logout();
    });
};

export const searchTxnRef = (reference) =>
{
    return fetch(`${API}/transaction/search-txn/` + reference, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${isAuthenticated()}`,
        },
    }).then(handleResponse).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
};

export const getReceiptUrl = (receiptRequestBody) =>
{
    return fetch(`${API}/transaction/generateReceipt`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            // 'webhook-url': receiptRequestBody.webhookUrl,
            Authorization: `Bearer ${isAuthenticated()}`,
        }, body: JSON.stringify(receiptRequestBody),
    }).then(handleResponse).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
};

export const passwordReset = (body) =>
{
    return fetch(`${API}/web/password-reset`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const updatePassword = (body) =>
{
    return fetch(`${API}/web/update-password`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const resetPasswordApi = (body) =>
{
    return fetch(`${API}/sms/initiate-password-reset`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const initiateRegistrationAPI = (body) =>
{
    return fetch(`${API}/web/initiate-registration`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const registerUser = (body) =>
{
    return fetch(`${API}/web/validate-signup-token`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const getTokenApi = (body) =>
{
    // console.log("API URL: " + `${API}/sms/initiate-verification`);
    // console.log("getTokenApi body: " + JSON.stringify(body));

    return fetch(`${API}/sms/initiate-verification`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            // 'Access-Control-Allow-Origin': 'https://techpay.ebs-rcm.com',
            // 'Access-Control-Allow-Methods': 'POST, GET, PUT',
            // 'Access-Control-Allow-Headers': 'Content-Type'

        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const updateUser = (body) =>
{
    return fetch(`${API}/user/update_web`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${isAuthenticated()}`,
        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

// export const loginUser = (body) =>
// {
//     return fetch(`${API}/auth/user-login`, {
//         method: 'POST',
//         headers: {
//             Accept: 'application/json',
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(body),
//     }).then(response =>
//     {
//         return response.json();
//     }).catch(err =>
//     {
//         console.log(err);
//     });
// }

export const authenticateUser = (token) =>
{
    if (typeof window != 'undefined')
    {
        localStorage.setItem('techpay_token', token);
    }
};

export const isAuthenticated = () =>
{
    if (typeof window == 'undefined')
    {
        return false;
    }

    //TODO:
    // MAKE CALL TO REFRESH TOKEN AND UPDATE LOCAL STORAGE
    // refreshToken();

    if (localStorage.getItem('techpay_token'))
    {
        return localStorage.getItem('techpay_token');
    } else
    {
        return false;
    }
};

export const setTechPayReceiptUrl = (techpay_receipt_url) =>
{
    if (typeof window != 'undefined')
    {
        localStorage.setItem('techpay_receipt_url', techpay_receipt_url);
    }
};

export const getTechPayReceiptUrl = () =>
{
    if (typeof window == 'undefined')
    {
        return false;
    }
    if (localStorage.getItem('techpay_receipt_url'))
    {
        return localStorage.getItem('techpay_receipt_url');
    } else
    {
        return false;
    }
};

export const logout = () =>
{
    if (typeof window != 'undefined')
    {
        logoutUser();
        localStorage.removeItem('techpay_token')
        window.location.replace("/")
    }
}

// export const resetPassowrd = (body) =>
// {
//     return fetch(`${API}/sms/check-password-reset-verification-code`, {
//         method: 'POST',
//         headers: {
//             Accept: 'application/json',
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(body),
//     }).then(response =>
//     {
//         return response.json();
//     }).catch(err =>
//     {
//         console.log(err);
//     });
// }